import cx from 'classnames';
import Text from '../Text/Text';

import { ReactComponent as ArrowRightSvg } from '@frontend/icons/arrow-right.svg';

import { BoxStyleProps } from '../Box';
import Box from '../Box/Box';
import Icon from '../Icon/Icon';
import styles from './MethodCategoryOption.module.css';
import Loader from '../Loader/Loader';
import Image from '../Image/Image';

interface MethodCategoryOptionProps extends BoxStyleProps {
  className?: string;
  name: string;
  icon?: React.ReactNode;
  description?: string;
  helperMessage?: string;
  disabled?: boolean;
  loading?: boolean;
  stackAssets?: { assetSrc: string; alt: string }[];
  onClick: () => void;
}

export default function MethodCategoryOption({
  className,
  name,
  description,
  icon,
  helperMessage,
  disabled,
  loading,
  stackAssets,
  ...otherProps
}: MethodCategoryOptionProps): JSX.Element {
  const isDisabled = disabled || loading;

  return (
    <Box
      as="button"
      className={cx(styles['base'], className)}
      {...otherProps}
      disabled={isDisabled}
    >
      <div className={styles['inner-container']}>
        <div className={styles['left-container']}>
          <div className={styles['name-container']}>
            <div className={styles['icon-container']}>{icon}</div>
            <Text
              as="div"
              weight="600"
              size="large"
              color={isDisabled ? 'neutral-400' : 'neutral-900'}
            >
              {name}
            </Text>
          </div>
          <Text
            as="p"
            mb="0"
            mt="8"
            size="small"
            color={isDisabled && !helperMessage ? 'neutral-400' : 'neutral-500'}
            align="left"
          >
            {helperMessage || description}
          </Text>
          {stackAssets && (
            <div className={styles['stack-assets-wrapper']}>
              <div className={styles['stack-assets-container']}>
                {stackAssets.map((asset, index) => (
                  <div key={index} className={styles['stack-asset-container']}>
                    <Image
                      className={styles['stack-asset']}
                      src={asset.assetSrc}
                      alt={asset.assetSrc}
                    />
                  </div>
                ))}
              </div>
              <Text size="tiny" color="neutral-500">
                +More
              </Text>
            </div>
          )}
        </div>
        {loading ? (
          <Loader />
        ) : (
          <Icon
            component={<ArrowRightSvg />}
            size={24}
            color={isDisabled ? 'neutral-400' : 'neutral-500'}
          />
        )}
      </div>
    </Box>
  );
}
